module.exports = __webpack_public_path__ + "img/no_data_apply.b3330a84.jpg";